import { trackCioEvent } from '../cio';
import { identifyUser } from '../identifyUser';
import { AnalyticsEvent } from '../types';

export type InputPatientSelectedCategoryEventProperties = {
  email: string;
  supplyCategories: string[];
};

export function trackInputPatientSelectedCategory(
  properties: InputPatientSelectedCategoryEventProperties
) {
  if (properties.email) {
    void identifyUser(properties.email, {
      supplyCategories: properties.supplyCategories,
    });
  }

  // TODO: Deprecate this event after campaign is removed:
  // https://linear.app/conduithealth/issue/ENG-1605/dtc-cio-campaing-input-patient-selected-category
  // CIO campaign still keys off legacy `supply_category` (do not send only camelCase).
  trackCioEvent(AnalyticsEvent.INPUT_PATIENT_SELECTED_CATEGORY, {
    email: properties.email,
    supply_category: properties.supplyCategories,
  });
}
